import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Pelanggan Company")
], -1)
const _hoisted_3 = { class: "table-custom mb-3" }
const _hoisted_4 = { class: "row-header" }
const _hoisted_5 = { class: "text-xs font-normal color-blue-grey" }
const _hoisted_6 = {
  key: 0,
  class: "con-col-1 w-full"
}
const _hoisted_7 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_8 = {
  key: 0,
  style: {"color":"#43A047"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"#FF9800"}
}
const _hoisted_10 = { class: "flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_PaginatorUrl = _resolveComponent("PaginatorUrl")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_ModalCompany = _resolveComponent("ModalCompany")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              placeholder: "Cari Disini ...",
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              canClick: true,
              onSubmitInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitSearch(_ctx.inputSearch))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitSearch(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("table", _hoisted_3, [
          _createVNode("tr", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
              return (_openBlock(), _createBlock("th", { key: index }, [
                _createVNode("p", _hoisted_5, _toDisplayString(col.title), 1)
              ]))
            }), 128))
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (val, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: index,
              class: `row-content ${val.Level === 1 ? 'row-child child-'+val.BranchFrom : 'row-group'}`
            }, [
              _createVNode("td", null, [
                (val.Level === 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("p", {
                        class: "color-primary cursor-pointer font-bold",
                        onClick: ($event: any) => (_ctx.goToDetail(val))
                      }, _toDisplayString(_ctx.nameEmpty(val.Fullname)), 9, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (val.Level === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      (val.Branchs.length > 0)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "mr-4 cursor-pointer",
                            onClick: ($event: any) => (_ctx.showChild(`${val.Id}`))
                          }, [
                            _createVNode("i", {
                              id: `icon-${val.Id}`,
                              class: "pi pi-angle-down"
                            }, null, 8, ["id"])
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", null, [
                        _createVNode("p", {
                          class: "color-primary cursor-pointer font-bold",
                          onClick: ($event: any) => (_ctx.goToDetail(val))
                        }, _toDisplayString(_ctx.nameEmpty(val.Fullname)), 9, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("td", null, [
                _createVNode("p", null, _toDisplayString(_ctx.nameEmpty(val.Kota)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", null, _toDisplayString(_ctx.nameEmpty(val.Kode)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", null, _toDisplayString(_ctx.nameEmpty(val.Email)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", null, _toDisplayString(_ctx.nameEmpty(val.PhoneNumber)), 1)
              ]),
              _createVNode("td", null, [
                (val.GroupUserId == 16)
                  ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.nameEmpty(val.GroupUserName)), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.nameEmpty(val.GroupUserName)), 1))
              ]),
              _createVNode("td", null, [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_InputSwitch, {
                    class: "switch-og",
                    modelValue: val.IsActive,
                    "onUpdate:modelValue": ($event: any) => (val.IsActive = $event),
                    onChange: ($event: any) => (_ctx.changeIsActive(val)),
                    disabled: !_ctx.route.meta.permission.update
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]),
                  _createVNode("i", {
                    class: "pi pi-ellipsis-h text-base cursor-pointer text-black ml-3",
                    "aria:haspopup": "true",
                    onClick: ($event: any) => (_ctx.showDropDown($event, val))
                  }, null, 8, ["onClick"])
                ])
              ])
            ], 2))
          }), 128))
        ]),
        _createVNode("div", null, [
          (_ctx.dataSource.length > 0)
            ? (_openBlock(), _createBlock(_component_PaginatorUrl, {
                key: 0,
                onOnPage: _ctx.onPage,
                totalRecords: _ctx.totalRecords
              }, null, 8, ["onOnPage", "totalRecords"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          changeDeposit: _ctx.route.meta.permission.update && _ctx.dataForm.IsCanPaylater,
          changeCutoffDate: _ctx.route.meta.permission.update && _ctx.dataForm.IsCanPaylater,
          transLimit: _ctx.route.meta.permission.update,
          discountLevel: _ctx.route.meta.permission.update,
          nonActivateTop: _ctx.route.meta.permission.update && _ctx.dataForm.IsCanPaylater,
          activateTop: _ctx.route.meta.permission.update && !_ctx.dataForm.IsCanPaylater,
          onChangeDeposit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('ActivateTop', _ctx.dataForm))),
          onChangeCutoffDate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('ChangeCutoffDate', _ctx.dataForm))),
          onActivateTop: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeActivateTOP(true, _ctx.dataForm))),
          onNonActivateTop: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeActivateTOP(false, _ctx.dataForm))),
          onDiscountLevel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModal('ChangeDiscountLevel', _ctx.dataForm))),
          onTransLimit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openModal('ChangeTransactionLimits', _ctx.dataForm)))
        }, null, 8, ["changeDeposit", "changeCutoffDate", "transLimit", "discountLevel", "nonActivateTop", "activateTop"])
      ]),
      _: 1
    }, 512),
    (_ctx.isShowModalCompany)
      ? (_openBlock(), _createBlock(_component_ModalCompany, {
          key: 0,
          isShow: _ctx.isShowModalCompany,
          data: _ctx.dataForm,
          from: _ctx.fromModal,
          onHideDialog: _ctx.hideModalCompany
        }, null, 8, ["isShow", "data", "from", "onHideDialog"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}